document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".delivery-info");
  if (!container) return;

  // Funktion zum Lesen der aktuellen Einstellungen
  function getCurrentSettings() {
    return {
      deliveryDays: parseInt(container.dataset.deliveryDays, 10),
      cutoffHour: parseInt(container.dataset.orderCutoff, 10),
      pickupDays: {
        1: container.dataset.pickupMonday === "true",
        2: container.dataset.pickupTuesday === "true",
        3: container.dataset.pickupWednesday === "true",
        4: container.dataset.pickupThursday === "true",
        5: container.dataset.pickupFriday === "true",
        6: container.dataset.pickupSaturday === "true",
      },
    };
  }

  // Hilfsfunktion: Finde den nächsten Abholtag
  function findNextPickupDay(startDate, pickupDays) {
    const date = new Date(startDate);
    let daysChecked = 0;

    // Maximal 7 Tage prüfen um Endlosschleifen zu vermeiden
    while (daysChecked < 7) {
      const dayOfWeek = date.getDay();

      // Sonntag (0) überspringen
      if (dayOfWeek === 0) {
        date.setDate(date.getDate() + 1);
        daysChecked++;
        continue;
      }

      // Prüfen ob dieser Tag ein Abholtag ist
      if (pickupDays[dayOfWeek]) {
        return new Date(date);
      }

      date.setDate(date.getDate() + 1);
      daysChecked++;
    }

    // Fallback: nächster Montag
    return new Date(startDate);
  }

  // Hilfsfunktion: Addiere Liefertage, überspringe Sonntage
  function addDeliveryDays(startDate, days) {
    const date = new Date(startDate);
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0) added++; // Sonntag überspringen
    }
    return date;
  }

  // Hilfsfunktion: Bestellabwicklungstag berechnen
  function getOrderHandlingDate(now, cutoffHour, pickupDays) {
    const orderDate = new Date(now);
    const currentDay = orderDate.getDay();
    const currentHour = orderDate.getHours();

    // Sonntag - immer zum nächsten Abholtag
    if (currentDay === 0) {
      return findNextPickupDay(orderDate, pickupDays);
    }

    // Prüfen ob heute ein Abholtag ist
    if (!pickupDays[currentDay]) {
      // Heute ist kein Abholtag - zum nächsten Abholtag
      return findNextPickupDay(orderDate, pickupDays);
    }

    // Heute ist ein Abholtag - prüfen ob nach Cutoff
    if (currentHour >= cutoffHour) {
      // Nach Cutoff - zum nächsten Abholtag
      orderDate.setDate(orderDate.getDate() + 1);
      return findNextPickupDay(orderDate, pickupDays);
    }

    // Vor Cutoff und heute ist Abholtag - heute
    return new Date(orderDate);
  }

  // Lieferdatum berechnen
  function updateDeliveryDate() {
    const settings = getCurrentSettings();
    const now = new Date();
    const handlingDate = getOrderHandlingDate(
      now,
      settings.cutoffHour,
      settings.pickupDays
    );
    const deliveryDate = addDeliveryDays(handlingDate, settings.deliveryDays);

    function formatDate(date) {
      return (
        ("0" + date.getDate()).slice(-2) +
        "." +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "." +
        date.getFullYear()
      );
    }
    document.getElementById("deliveryDate").textContent =
      formatDate(deliveryDate);
  }

  // Countdown bis Bestellschluss
  function updateCountdown() {
    const settings = getCurrentSettings();
    const now = new Date();
    const currentDay = now.getDay();
    const currentHour = now.getHours();
    const currentMinutes = now.getMinutes();

    let nextCutoff = null;

    // Wenn heute ein Abholtag ist und vor Cutoff
    if (settings.pickupDays[currentDay] && currentHour < settings.cutoffHour) {
      // Heute noch möglich - Cutoff heute
      nextCutoff = new Date(now);
      nextCutoff.setHours(settings.cutoffHour, 0, 0, 0);
    } else {
      // Heute nicht möglich - nächster Abholtag
      let searchStartDate = new Date(now);

      // Wenn heute ein Abholtag ist aber nach Cutoff, starte Suche ab morgen
      if (
        settings.pickupDays[currentDay] &&
        currentHour >= settings.cutoffHour
      ) {
        searchStartDate.setDate(searchStartDate.getDate() + 1);
      }

      const nextPickup = findNextPickupDay(
        searchStartDate,
        settings.pickupDays
      );
      nextCutoff = new Date(nextPickup);
      nextCutoff.setHours(settings.cutoffHour, 0, 0, 0);
    }

    const diff = nextCutoff - now;

    // Sicherheitscheck für negative Werte
    if (diff <= 0) {
      // Nochmal zum nächsten Abholtag
      const nextPickup = findNextPickupDay(now, settings.pickupDays);
      nextCutoff = new Date(nextPickup);
      nextCutoff.setHours(settings.cutoffHour, 0, 0, 0);
      const newDiff = nextCutoff - now;

      if (newDiff <= 0) {
        // Fallback: nächster Montag
        const monday = new Date(now);
        let daysUntilMonday = (8 - monday.getDay()) % 7;
        if (daysUntilMonday === 0) daysUntilMonday = 7;
        monday.setDate(monday.getDate() + daysUntilMonday);
        monday.setHours(settings.cutoffHour, 0, 0, 0);
        nextCutoff = monday;
      } else {
        nextCutoff = new Date(nextPickup);
        nextCutoff.setHours(settings.cutoffHour, 0, 0, 0);
      }
    }

    const finalDiff = nextCutoff - now;

    const days = Math.floor(finalDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (finalDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((finalDiff % (1000 * 60 * 60)) / (1000 * 60));

    let timeText = "";
    if (days > 0) {
      timeText = days + " Tag(e) " + hours + " Std. " + minutes + " Min.";
    } else {
      timeText = hours + " Std. " + minutes + " Min.";
    }

    document.getElementById("deliveryCountdown").textContent = timeText;
  }

  // Initial update
  updateDeliveryDate();
  updateCountdown();

  // Update every minute
  setInterval(function () {
    updateDeliveryDate();
    updateCountdown();
  }, 60000);
});
